/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { WhatsappReportRequestDto } from '../models/whatsapp-report-request-dto';
import { WhatsappReportResponseDto } from '../models/whatsapp-report-response-dto';

@Injectable({
  providedIn: 'root',
})
export class WhatsappDeliveryReportControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getSmsDeliveryReports
   */
  static readonly GetSmsDeliveryReportsPath = '/api/v1/delivery-report';

  /**
   * Get SMS delivery report.
   *
   * The API to get Delivery report if records<50
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSmsDeliveryReports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSmsDeliveryReports$Response(params?: {
    body?: WhatsappReportRequestDto
  }): Observable<StrictHttpResponse<WhatsappReportResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, WhatsappDeliveryReportControllerService.GetSmsDeliveryReportsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WhatsappReportResponseDto>;
      })
    );
  }

  /**
   * Get SMS delivery report.
   *
   * The API to get Delivery report if records<50
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSmsDeliveryReports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSmsDeliveryReports(params?: {
    body?: WhatsappReportRequestDto
  }): Observable<WhatsappReportResponseDto> {

    return this.getSmsDeliveryReports$Response(params).pipe(
      map((r: StrictHttpResponse<WhatsappReportResponseDto>) => r.body as WhatsappReportResponseDto)
    );
  }

}
